@if (!entry || entry.base?.display) {
  <div>
    <div class="instructions-list-header">
      <p>Instructions for uploading your files</p>
    </div>
    <ul class="instructions-list">
      @if (customConfigs.minDocuments) {
        <li>A minimum of <strong>{{customConfigs.minDocuments}}</strong> document{{customConfigs.minDocuments > 1 ? 's' : ''}} must be uploaded</li>
      }
      <li>A maximum of <strong>{{maxUploadFileNumber}}</strong> document{{maxUploadFileNumber > 1 ? 's' : ''}} can be uploaded</li>
      <li>Single file size limit is <strong>{{fileSizeLimitInMB}}</strong> MB</li>
      <li>Click the <strong>"Upload" button</strong> to upload individual files</li>
      @if (customConfigs?.fifthBullet) {
        <span [innerHTML]="customConfigs?.fifthBullet"></span>
      }
    </ul>
    @if(customConfigs?.additionalInstructions){
      <div [innerHTML]="customConfigs?.additionalInstructions"></div>
    }
    <!-- TABLE DISPLAY -->
    @if (fileDisplayArray && fileDisplayArray.length) {
      <table class="file-table">
        <!-- HEADER -->
        <thead>
          <tr>
            @for (header of displayedColumns; track $index; let i = $index) {
              <th class="header-cell">{{header}}</th>
            }
          </tr>
        </thead>
        <!-- BODY -->
        <tbody>
          <!-- FILE LIST -->
          @for (fileObj of fileDisplayArray; track $index; let i = $index) {
            <tr [app-file-display-with-modal]
              #FileDisplayComponent
              [displayableFileObj]="fileObj"
              [actualFileObj]="fileListArray[i]"
              [index]="i"
              [allowedExtensions]="allowedExtensions"
              [fileSizeLimitInMB]="fileSizeLimitInMB"
              [canUploadMoreFiles]="canUploadMoreFiles"
              [customPayloadAdditions]="addPayloadAdditions()"
              [onUploadFile]="onUploadFile()"
              [onRemoveFile]="onRemoveFile()"
              [disableRemoveButtonOnSuccess]="customConfigs?.disableRemoveButtonOnSuccess"
              >
            </tr>
          }
          <!-- ADDITIONAL FILES / UPLOAD ALL / REMOVE ALL -->
          <tr>
            <!-- ADD FILES -->
            <td [attr.colspan]="'3'">
              <!-- DISPLAY: NONE -->
              <input #hiddenfileinput_additional
                style="display: none;"
                type="file"
                id="file"
                class="file-input"
                [accept]="allowedExtensionsAsString"
                (change)="onHandleFileInput($event, $event.target.files)" />
                <!-- Accepted file types: .doc, .docx, .xls, .xlsx, .txt, .rtf, .png, .jpg, .tif, .bmp, .ppt, .pptx, .pdf -->
                <!-- DISPLAY: VISIBLE -->
                <button mat-raised-button color="accent" [disabled]="!canAddMoreFiles" (click)="hiddenfileinput_additional.click()">
                  Add Another File
                </button>
              </td>
              <!-- UPLOAD ALL -->
              <td>
                @if (fileListArray && fileListArray.length > 1) {
                  <button
                    mat-raised-button
                    class="handle-all-files-button"
                    color="primary"
                    [ngClass]="{
                      'interactable': canUploadMoreFiles,
                      'disabled': !canUploadMoreFiles
                    }"
                    (click)="uploadAllFiles()"
                    >
                    Upload All
                  </button>
                }
              </td>
              <!-- REMOVE ALL -->
              <td>
                @if (fileListArray && fileListArray.length > 1) {
                  <button mat-raised-button class="handle-all-files-button" (click)="removeAllFiles()">
                    Remove All
                  </button>
                }
              </td>
            </tr>
          </tbody>
        </table>
      } @else {
        <!-- DISPLAY: NONE -->
        <input #hiddenfileinput_initial
          style="display: none;"
          type="file"
          id="file"
          class="file-input"
          [accept]="allowedExtensionsAsString"
          (change)="onHandleFileInput($event, $event.target.files)" />
          <!-- Accepted file types: .doc, .docx, .xls, .xlsx, .txt, .rtf, .png, .jpg, .tif, .bmp, .ppt, .pptx, .pdf -->
          <!-- DISPLAY: VISIBLE -->
          <button class="file-upload-button" mat-raised-button color="primary" (click)="hiddenfileinput_initial.click()">
            File Upload
          </button>
        }
        <!-- FIRST-TIME BUTTON -->
      </div>
    }